<template>
	<div class="app-container">
		<div class="header">
			<!-- <el-input size="medium" v-model="search" placeholder="输入车辆品牌,按回车键搜索" @keyup.enter.native="carSearch()"
				class="search" />
			<el-button icon="el-icon-search" @click="carSearch()" type="primary" class="btnInsert">搜索</el-button>
 -->
			<el-select v-model="select" slot="prepend" :placeholder="this.$t('carsmanage.cardata.hint1')" style="width: 160px">
				<el-option :label="this.$t('carsmanage.cardata.select.brandcn')" value="1"></el-option>
				<el-option :label="this.$t('carsmanage.cardata.select.branden')" value="2"></el-option>
				<el-option :label="this.$t('carsmanage.cardata.select.model')" value="3"></el-option>
				<el-option :label="this.$t('carsmanage.cardata.select.year')" value="4"></el-option>
				<el-option :label="this.$t('carsmanage.cardata.select.configuration')" value="5"></el-option>
			</el-select>
			<el-input :placeholder="this.$t('carsmanage.cardata.hint2')" v-model="search" class="input-with-select" style="width: 60%;">
				<el-button type="info" slot="append" @click="carSearch()" icon="el-icon-search"></el-button>
			</el-input>
			
			<el-button type="success" size="mini" @click="openInsertCar" class="btnInsert">{{$t('carsmanage.cardata.insert.title')}}
			</el-button>
		</div>
		
		<el-table :data="cars" style="width: 100%">
			<el-table-column label="id" prop="" width="80px" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-span type='text'>{{scope.row.carId}}</el-span>
				</template>
			</el-table-column>

			<el-table-column width="120" :label="this.$t('carsmanage.cardata.brandcn')" prop="brandC"> </el-table-column>
			<el-table-column width="140" :label="this.$t('carsmanage.cardata.branden')" prop="brandE"> </el-table-column>
			<el-table-column width="120" :label="this.$t('carsmanage.cardata.model')" prop="type"> </el-table-column>
			<el-table-column width="120" :label="this.$t('carsmanage.cardata.year')" prop="year"> </el-table-column>
			<el-table-column width="150" :label="this.$t('carsmanage.cardata.configuration')" prop="" show-overflow-tooltip>
				<template slot-scope="scope">
					<i slot="reference">{{scope.row.configuration}}</i>
				</template>
			</el-table-column>
			<el-table-column :label="this.$t('carsmanage.cardata.createtime')" prop="createTime"> </el-table-column>


			<el-table-column :label="this.$t('carsmanage.cardata.operate')" prop="">
				<template slot-scope="scope">
					<el-tag type="warning" class="btn" @click="openUpdateCar(scope.row)">{{$t('carsmanage.cardata.modify.btn')}}</el-tag>
					<el-tag type="danger" class="btn" @click="deleteOneCar(scope.row.carId)">{{$t('carsmanage.cardata.delete')}}</el-tag>
				</template>
			</el-table-column>
		</el-table>

		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
			:page-sizes="[5, 10, 15, 20]" :page-size="length" layout="total, sizes, prev, pager, next, jumper"
			:total="total" class="pagination">
		</el-pagination>
		<!-- 新增、修改车辆框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form :model="carForm">
				<el-form-item :label="this.$t('carsmanage.cardata.modify.id')" :label-width="formLabelWidth" v-if="dialogTitle == this.$t('carsmanage.cardata.modify.title')">
					<el-input v-model="carForm.carId" autocomplete="off" @input="change($event)" disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.cardata.createtime')" :label-width="formLabelWidth" v-if="dialogTitle == this.$t('carsmanage.cardata.modify.title')">
					<el-input v-model="carForm.createTime" autocomplete="off" @input="change($event)" disabled="true">
					</el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.cardata.brandcn')" :label-width="formLabelWidth">
					<el-input v-model="carForm.brandC" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.cardata.branden')" :label-width="formLabelWidth">
					<el-input v-model="carForm.brandE" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.cardata.model')" :label-width="formLabelWidth">
					<el-input v-model="carForm.type" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.cardata.year')" :label-width="formLabelWidth">
					<el-input v-model="carForm.year" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
				<el-form-item :label="this.$t('carsmanage.cardata.configuration')" :label-width="formLabelWidth">
					<el-input v-model="carForm.configuration" autocomplete="off" @input="change($event)"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancle()">{{$t('carsmanage.cardata.modify.cancel')}}</el-button>
				<el-button type="primary" @click="toCar()">{{btnName}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				cars: [{
						carId: '',
						brand: '',
						type: '',
						year: '',
						createTime: '',
						configuration: ''
					},
					{
						carId: '',
						carBrand: '',
						carType: '',
						carYear: '',
						createTime: '',
						carConfiguration: ''
					}
				],
				carForm: {
					carId: '',
					brand: '',
					type: '',
					year: '',
					createTime: '',
					configuration: ''
				},
				search: "",
				select: '',
				length: 5,
				page: 1,
				total: 0,
				dialogWidth: "30%",
				dialogTitle: '新增车辆',
				dialogFormVisible: false,
				btnName: '新增',
				formLabelWidth: '120px'
			};
		},
		created() {
			this.reload();
		},
		methods: {
			change(e) {
				this.$forceUpdate();
			},
			reload() {
				let that = this;
				let length = that.length;
				let page = that.page;
				let select = that.select;
				let search = that.search;

				if (search == '' || select == '') {
					that.getRequest('/tpa-api/manageCar/getCarInfo?length=' + length + '&page=' + page + '&option=0',
						null).then(
						resp => {
							if (resp.code == 200) {
								that.cars = resp.result;
								that.total = resp.total;
							}
						});
				}
				if (select == 1 || select == 2 || select == 3 || select == 4 || select == 5) {
					that.getRequest('/tpa-api/manageCar/getCarInfo?length=' + length + '&page=' + page + '&keyword=' +
						search + '&option=' + select,
						null).then(
						resp => {
							if (resp.code == 200) {
								that.cars = resp.result;
								that.total = resp.total;
							}
						});
				}
			},
			// 分页功能
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.length = val;
				this.reload();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.reload();
			},
			cancle() {
				this.dialogFormVisible = false;
				this.reload();
			},
			carSearch() {
				let that = this;
				let length = that.length;
				let page = that.page = 1;
				let search = that.search;
				let select = that.select;
				
				if(select == ''){
					this.$message(this.$t('notification.cardatamessage'));
				}
				
				if (search == '') {
					page = that.page;
					that.getRequest('/tpa-api/manageCar/getCarInfo?length=' + length + '&page=' + page + '&keyword=' +
						search + '&option=0',
						null).then(
						resp => {
							if (resp.code == 200) {
								that.cars = resp.result;
								that.total = resp.total;
							}
						});
				}
				if (select == 1 || select == 2 || select == 3 || select == 4 || select == 5) {
					that.getRequest('/tpa-api/manageCar/getCarInfo?length=' + length + '&page=' + page + '&keyword=' +
						search + '&option=' + select,
						null).then(
						resp => {
							if (resp.code == 200) {
								that.cars = resp.result;
								that.total = resp.total;
							}
						});
				}

			},
			openInsertCar() {
				this.carForm = {};
				this.dialogTitle = this.$t('carsmanage.cardata.insert.title');
				this.btnName = this.$t('carsmanage.cardata.insert.btn');
				this.dialogFormVisible = true;
			},
			openUpdateCar(row) {
				this.carForm.carId = row.carId;
				this.carForm.brandC = row.brandC;
				this.carForm.brandE = row.brandE;
				this.carForm.type = row.type;
				this.carForm.year = row.year;
				this.carForm.createTime = row.createTime;
				this.carForm.configuration = row.configuration;
				this.dialogFormVisible = true;
				this.dialogTitle = this.$t('carsmanage.cardata.modify.title');
				this.btnName = this.$t('carsmanage.cardata.modify.btn');
			},
			deleteOneCar(id) {
				// 跳出确认框
				let that = this;
				that.$confirm(this.$t('notification.cardatadeletemessage'), this.$t('notification.title'), {
					confirmButtonText: this.$t('notification.confirm'),
					cancelButtonText: this.$t('notification.cancel'),
					type: 'warning'
				}).then(() => {
					// 发送ajax请求删除数据
					that.deleteRequest('/tpa-api/manageCar/deleteCarInfo/' + id, null).then(resp => {
						if (resp.code == 200) {
							// let index = that.cars.findIndex(one => {
							// 	if (one.id == id) {
							// 		return true;
							// 	}
							// });
							// // 删除carInfo中被删除的内容
							// that.cars.splice(index, 1)
							// 重新加载
							that.page = 1;
							that.length = 5;
							that.reload();
						}
					});
				}).catch(() => {
					that.$message({
						type: 'info',
						message: this.$t('notification.cancelinfo')
					});
				});
			},
			toCar() {
				let that = this;
				let btnName = that.btnName;
				let insertData = {
					brandC: that.carForm.brandC,
					brandE: that.carForm.brandE,
					type: that.carForm.type,
					year: that.carForm.year,
					configuration: that.carForm.configuration
				};
				if (btnName == this.$t('carsmanage.cardata.insert.btn')) {
					that.postRequest('/tpa-api/manageCar/insertCarInfo', insertData).then(
						resp => {
							if (resp.code == 200) {
								// 关闭对话框，刷新页面
								that.dialogFormVisible = false;
								that.reload();
							}
						});
				} else if (btnName == this.$t('carsmanage.cardata.modify.btn')) {
					let updateData = {
						carId: that.carForm.carId,
						brandC: that.carForm.brandC,
						brandE: that.carForm.brandE,
						type: that.carForm.type,
						year: that.carForm.year,
						configuration: that.carForm.configuration
					};
					that.postRequest('/tpa-api/manageCar/updateCarInfo', updateData).then(
						resp => {
							if (resp.code == 200) {
								// 关闭对话框，刷新页面
								that.dialogFormVisible = false;
								that.reload();
							}
						});
				}
			}

		}
	};
</script>
<style scoped>
	.avatar {
		height: 50px;
	}

	.pagination {
		display: flex;
		float: left;
		margin-left: 10px;
		margin-top: 40px;
	}

	.btnInsert {
		margin-left: 50px;
		height: 36px;
		font-size: 10px;
		line-height: 10px;
		float: right;
	}

	.search {
		width: 30%;
		height: 50px;

	}

	.header {
		display: flex;
		flex-direction: row;
	}

	.btn {
		cursor: pointer;
	}
</style>
